import { Security } from "@okta/okta-react";
import { AlertProvider, BCR, BCRTheme, LoadingProvider, Milb } from "best-common-react";
import React from "react";
import HttpInterceptor from "../api/HttpInterceptor";
import { GlobalProvider } from "../contexts/GlobalContext";
import { oktaAuth, UserProvider } from "../contexts/UserContext";
import { QueryProvider } from "../providers/QueryProvider";

const WrapperProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const bcrTheme: BCRTheme | undefined = searchParams.get("bcrTheme") as BCRTheme | undefined;

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string): Promise<void> => {
    window.location.replace(originalUri);
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <UserProvider>
        <QueryProvider>
          <AlertProvider>
            <LoadingProvider>
              <HttpInterceptor>
                <BCR theme={bcrTheme ?? Milb}>
                  <GlobalProvider>{children}</GlobalProvider>
                </BCR>
              </HttpInterceptor>
            </LoadingProvider>
          </AlertProvider>
        </QueryProvider>
      </UserProvider>
    </Security>
  );
};

export default WrapperProvider;
